import {
  Converter,
  ConverterService,
  Occ,
  PRODUCT_NORMALIZER,
} from '@spartacus/core'
import { Injectable } from '@angular/core'
import { OccOrderNormalizer } from '@spartacus/order/occ'
import { Order } from '@spartacus/order/root'
import { ORDER_ENTRY_PROMOTIONS_NORMALIZER, OrderEntry, PromotionResult } from '@spartacus/cart/base/root'

@Injectable({
  providedIn: 'root'
})
export class OccMbOrderNormalizer extends OccOrderNormalizer implements Converter<Occ.Order, Order> {

  constructor (protected converterService: ConverterService) {
    super(converterService)
  }

  convert (source: Occ.Order, target?: Order) {
    super.convert(source, target)
    if (target === undefined) {
      target = { ...source } as Order
    }
    if (source.entries) {
      target.entries = source.entries.map(entry => this.convertMbOrderEntry(entry, source.code, source.appliedProductPromotions))
    }
    return target
  }

  private convertMbOrderEntry (source?: Occ.OrderEntry, code?: string, promotions?: PromotionResult[]) {
    return {
      ...source,
      entries: this.convertChildEntries(source),
      product: this.converterService.convert(source?.product, PRODUCT_NORMALIZER),
      orderCode: code,
      promotions: this.converterService.convert({ item: source, promotions: promotions },
        ORDER_ENTRY_PROMOTIONS_NORMALIZER
      ),
    } as OrderEntry
  }

  private convertChildEntries (source?: Occ.OrderEntry) {
    return source?.entries?.map(entry => ({
      ...entry,
      product: this.converterService.convert(entry?.product, PRODUCT_NORMALIZER)
    }))
  }
}
